import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import ReactGA from "react-ga4";
import mixpanel from "mixpanel-browser";
import "./styles/tailwind.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";

if (process.env.REACT_APP_MIXPANEL_TOKEN) {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
    debug: false,
    track_pageview: false,
  });
} else {
  console.warn("MIXPANE token not configured");
}

if (
  process.env.REACT_APP_GA4_MEASUREMENT_ID &&
  process.env.REACT_APP_ENVIRONMENT === "production"
) {
  ReactGA.initialize(process.env.REACT_APP_GA4_MEASUREMENT_ID, {
    gtagOptions: {
      debug_mode: false,
    },
  });
} else {
  console.warn("GA4 MEASUREMENT ID not configured");
}

if (
  process.env.REACT_APP_SENTRY_DSN &&
  process.env.REACT_APP_ENVIRONMENT === "production"
) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT,
    sendDefaultPii: true,
    beforeSend(event, hint) {
      const error = hint.originalException;
      //Type guard to check if error is an Error instance
      if (error instanceof Error && error.name === "AbortError") {
        console.log("Filtered AbortError:", error);
        return null; // Do not report AbortError
      }

      // Optional: Filter axios canceled errors
      if (error instanceof Error && error.message?.includes("canceled")) {
        console.log("Filtered canceled error:", error);
        return null; // Do not report canceled errors
      }

      return event;
    },
  });
} else {
  console.warn("SENTRY_DSN not configured");
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
